import "./Navbar.css";
import "./ResponsiveNavbar.css";
import useNavbar from "./useNavbar";
import { NavLink, Route, Routes } from "react-router-dom";
import { getTranslatedText as translate } from "../Localization/Translation";
import logo from "./logo.jpg";
import Bronze from "../MedalsSVG/Bronze.svg";
import Diamond from "../MedalsSVG/Diamond.svg";
import Gold from "../MedalsSVG/Gold.svg";
import Silver from "../MedalsSVG/Silver.svg";
import LanguageSelection from "../LanguageSelection/LanguageSelect.js";
import Website from "../Website/Website.js";
import SettingsWebPage from "../SettingsWebPage/SettingsWebPage.js";
import NotificationsWebPage from "../NotificationsWebPage/NotificationsWebPage.js";
import OrdersWebPage from "../OrdersWebPage/OrdersWebPage.js";
import ContactUs from "../ContactUs/ContactUs";

function Navbar() {
  const {
    clickHamburger,
    clickTab,
    locale,
    userClassify,
    location,
    clickUser,
    setClickUser,
    onClickUser,
  } = useNavbar();

  return (
    <div
      className="Navbar"
      dir={locale === "EN" || locale === "HN" ? "ltr" : "rtl"}
    >
      <div className="nav-box-container">
        <div className="nav-container">
          <div className="hamburger" onClick={clickHamburger}>
            <span className="bar"></span>
            <span className="bar"></span>
            <span className="bar"></span>
          </div>

          <div className="name-lang-nav">
            {/* Switch Language */}
            <LanguageSelection />
            <div onClick={onClickUser}>
              <span className="current-user-navbar">
                {userClassify === "Bronze" ? (
                  <img src={Bronze} className="Bronze" alt="Bronze"></img>
                ) : userClassify === "Gold" ? (
                  <img src={Gold} className="Gold" alt="Gold"></img>
                ) : userClassify === "Diamond" ? (
                  <img src={Diamond} className="Diamond" alt="Diamond"></img>
                ) : userClassify === "Silver" ? (
                  <img src={Silver} className="Silver" alt="Silver"></img>
                ) : (
                  <></>
                )}
                {/* <i className="bi bi-person-circle"></i> */}
                <span>{translate("user-name", locale)}</span>
                <i className="bi bi-caret-down-fill"></i>
              </span>
              <NavLink to="/" className="nav-link-navbar">
                <span className="log-out-btn">
                  {translate("sign-out", locale)}
                  <i className="bi bi-box-arrow-left"></i>
                </span>
              </NavLink>
            </div>
          </div>

          <div className="nav-buttons d-flex justify-content-between row">
            {/* Tabs */}
            <NavLink
              to="/Navbar/Home/Search"
              className="Home-nav-tab nav-button current-tab nav-link-navbar col-1"
              onClick={() => clickTab(".Home-nav-tab")}
            >
              <span>{translate("main-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/Notifications"
              className="Notification-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".Notification-nav-tab")}
            >
              <span>{translate("notification-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/Orders/MyOrders"
              className="Orders-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".Orders-nav-tab")}
            >
              <span>{translate("orders-tab", locale)}</span>
            </NavLink>
            <NavLink
              to="/Navbar/Settings/Password"
              className="Settings-nav-tab nav-button nav-link-navbar col-1"
              onClick={() => clickTab(".Settings-nav-tab")}
            >
              <span>{translate("settings-tab", locale)}</span>
            </NavLink>

            {/* Logo */}
            <div className="nav-logo" dir="auto">
              <img src={logo} className="nav-logo-picture" alt="logo" />
            </div>
          </div>
        </div>
      </div>

      <Routes>
        <Route path="Home/*" element={<Website />} />
        <Route path="Settings/*" element={<SettingsWebPage />} />
        <Route path="Notifications/*" element={<NotificationsWebPage />} />
        <Route path="Orders/*" element={<OrdersWebPage />} />
        <Route path="ContactUs/*" element={<ContactUs />} />
      </Routes>
    </div>
  );
}

export default Navbar;
